import { useState, type KeyboardEvent } from "react";

interface Props {
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  inputId?: string;
}

/**
 * Comma/Enter-delimited tag input. Used for INQA "Beteiligte Rollen" and the
 * QM Handbuch beratungsfelder / zielgruppen / projektanlässe tag groups.
 */
export function TagInput({ values, onChange, placeholder, inputId }: Props) {
  const [text, setText] = useState("");

  function commit() {
    const trimmed = text.trim().replace(/,$/, "");
    if (!trimmed) return;
    if (values.includes(trimmed)) {
      setText("");
      return;
    }
    onChange([...values, trimmed]);
    setText("");
  }

  function onKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit();
    }
  }

  function remove(idx: number) {
    onChange(values.filter((_, i) => i !== idx));
  }

  return (
    <div className="tags-input-container">
      {values.map((value, i) => (
        <span className="tag-chip" key={`${value}-${i}`}>
          {value}
          <button type="button" title="Entfernen" onClick={() => remove(i)}>×</button>
        </span>
      ))}
      <input
        id={inputId}
        type="text"
        className="tags-input"
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={commit}
      />
    </div>
  );
}
